{
  "authority": "https://pentaxia-auth.osmm.devtank.co.uk",
  "client_id": "osm-portal",
  "client_secret": "03fwqSR5wkQOSecaEsTY0kICLPE45tm6",
  "apiUrl": "https://pentaxia-portal.osmm.devtank.co.uk/internal",
  "dbApi": "https://pentaxia-portal.osmm.devtank.co.uk/api",
  "dbToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiY3VzdG9tZXIifQ.2bEUVCFAB62KC98RJmkisEppW1FowGi1dY-tnmDAg3I"
}
